export const locales = {
    ru: {
        cartTitle: 'В корзине',
        cartTitleEmpty: 'В корзине пока нет блюд',
        cartPricePrefix: 'на',
    },
    en: {
        cartTitle: 'Your cart:',
        cartTitleEmpty: 'Your cart is empty',
        cartPricePrefix: '/',
    },
};
